<template>
  <div class="bread_crumbs">
    <Link01 />
    <Division />
    <Link02 :player="player" />
    <Division />
    <ActualSection />
  </div>
</template>

<script>
import Link01 from './Link01';
import Division from './Division';
import Link02 from './Link02';
import ActualSection from './ActualSection';
export default {
  name: 'BreadCrumbs',
  components: {
    Link01,
    Division,
    Link02,
    ActualSection,
  },
  props: {
    player: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style>
.bread_crumbs,
.bread_crumbs-1,
.bread_crumbs-2 {
  align-items: left;
  display: flex;
  margin-top: -10px;

  padding: 0px 0px 0px 4px;
  position: relative;
  width: 100%;
}
</style>
